import { getAllCategories } from "@/api/category";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

export const useCategories = () => {
  const [searchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const size = Number(searchParams.get("size")) || 10;
  const search = searchParams.get("search") ?? "";

  return useQuery({
    queryFn: () => getAllCategories({ page, size, search }),
    queryKey: ["categories", { page, size, search }],
    refetchOnMount: true
  });
};
